
import { useTranslation } from 'react-i18next';
import { useSEO, generateOrganizationSchema, generateWebPageSchema, generateServiceSchema, generateFAQSchema } from '../../utils/seo';
import Navbar from '../../components/feature/Navbar';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import ValuesSection from './components/ValuesSection';
import CTASection from './components/CTASection';
import ContactFooter from './components/ContactFooter';

const HomePage = () => {
  const { i18n } = useTranslation();
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://evesmart.qa';

  const title = 'إيف سمارت للخدمات الزراعية';
  const description = 'نقود ثورة تكنولوجية في القطاع الزراعي بدولة قطر. نتخصص في حلول الزراعة الذكية، الهيدروبونيك والزراعة الرأسية لدعم الأمن الغذائي الوطني ورؤية قطر 2030. Leading technological revolution in Qatar\'s agricultural sector with smart farming, hydroponics, and vertical farming solutions.';
  const keywords = 'الزراعة الذكية في قطر, الزراعة الرأسية, هيدروبونيك, ايف سمارت, smart agriculture Qatar, vertical farming, hydroponics, EVE Smart, Qatar agriculture';

  // Generate combined schema
  const combinedSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      generateOrganizationSchema(siteUrl),
      generateWebPageSchema(siteUrl, '/', title, description),
      generateServiceSchema(siteUrl),
      generateFAQSchema()
    ]
  };

  useSEO({
    title,
    description,
    keywords,
    canonical: `${siteUrl}/`,
    ogImage: 'https://static.readdy.ai/image/439cae8384efc9e7b28c054739e211d1/7857bf78d2c9072a724b80513f3fbc5c.png',
    schema: combinedSchema
  });

  return (
    <div>
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <ValuesSection />
      <CTASection />
      <ContactFooter />
    </div>
  );
};

export default HomePage;
